/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrsPayrollHist.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/DrsPayrollHist";

export class AutogenModelDrsPayrollHist<RowType extends ModelRow> extends Endpoint<RowType, RowDrsPayrollHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrsPayrollHist extends ModelRow<RowDrsPayrollHistFields> {
	constructor(values?: Partial<RowDrsPayrollHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrsPayrollHistFields {
	bonus_code_id: string;
	check_date: Date;
	check_number: string;
	city_tax_code: string;
	city_tax_wh: number;
	city_tax_wh_c: string;
	city_tax_wh_d: Date;
	city_tax_wh_n: number;
	city_tax_wh_r: number;
	city_wages: number;
	city_wages_c: string;
	city_wages_d: Date;
	city_wages_n: number;
	city_wages_r: number;
	company_id: string;
	county_tax_code: string;
	county_tax_wh: number;
	county_tax_wh_c: string;
	county_tax_wh_d: Date;
	county_tax_wh_n: number;
	county_tax_wh_r: number;
	county_wages: number;
	county_wages_c: string;
	county_wages_d: Date;
	county_wages_n: number;
	county_wages_r: number;
	credit_union_ded: number;
	credit_union_ded_c: string;
	credit_union_ded_d: Date;
	credit_union_ded_n: number;
	credit_union_ded_r: number;
	e401k_catch_wh: number;
	e401k_catch_wh_c: string;
	e401k_catch_wh_d: Date;
	e401k_catch_wh_n: number;
	e401k_catch_wh_r: number;
	e401k_wh: number;
	e401k_wh_c: string;
	e401k_wh_d: Date;
	e401k_wh_n: number;
	e401k_wh_r: number;
	employer_401k: number;
	employer_401k_c: string;
	employer_401k_d: Date;
	employer_401k_n: number;
	employer_401k_r: number;
	employer_ett: number;
	employer_ett_c: string;
	employer_ett_d: Date;
	employer_ett_n: number;
	employer_ett_r: number;
	employer_fica_hi: number;
	employer_fica_hi_c: string;
	employer_fica_hi_d: Date;
	employer_fica_hi_n: number;
	employer_fica_hi_r: number;
	employer_fica_ss: number;
	employer_fica_ss_c: string;
	employer_fica_ss_d: Date;
	employer_fica_ss_n: number;
	employer_fica_ss_r: number;
	employer_fui: number;
	employer_fui_c: string;
	employer_fui_d: Date;
	employer_fui_n: number;
	employer_fui_r: number;
	employer_sui: number;
	employer_sui_c: string;
	employer_sui_d: Date;
	employer_sui_n: number;
	employer_sui_r: number;
	ett_wages: number;
	ett_wages_c: string;
	ett_wages_d: Date;
	ett_wages_n: number;
	ett_wages_r: number;
	ett_wages_tot: number;
	ett_wages_tot_c: string;
	ett_wages_tot_d: Date;
	ett_wages_tot_n: number;
	ett_wages_tot_r: number;
	factoring_company_id: string;
	fed_tax_wh: number;
	fed_tax_wh_c: string;
	fed_tax_wh_d: Date;
	fed_tax_wh_n: number;
	fed_tax_wh_r: number;
	fed_wages: number;
	fed_wages_c: string;
	fed_wages_d: Date;
	fed_wages_n: number;
	fed_wages_r: number;
	fica_hi_wage_tot: number;
	fica_hi_wage_tot_c: string;
	fica_hi_wage_tot_d: Date;
	fica_hi_wage_tot_n: number;
	fica_hi_wage_tot_r: number;
	fica_hi_wages: number;
	fica_hi_wages_c: string;
	fica_hi_wages_d: Date;
	fica_hi_wages_n: number;
	fica_hi_wages_r: number;
	fica_hi_wh: number;
	fica_hi_wh_c: string;
	fica_hi_wh_d: Date;
	fica_hi_wh_n: number;
	fica_hi_wh_r: number;
	fica_ss_wage_tot: number;
	fica_ss_wage_tot_c: string;
	fica_ss_wage_tot_d: Date;
	fica_ss_wage_tot_n: number;
	fica_ss_wage_tot_r: number;
	fica_ss_wages: number;
	fica_ss_wages_c: string;
	fica_ss_wages_d: Date;
	fica_ss_wages_n: number;
	fica_ss_wages_r: number;
	fica_ss_wh: number;
	fica_ss_wh_c: string;
	fica_ss_wh_d: Date;
	fica_ss_wh_n: number;
	fica_ss_wh_r: number;
	fui_wages: number;
	fui_wages_c: string;
	fui_wages_d: Date;
	fui_wages_n: number;
	fui_wages_r: number;
	fui_wages_tot: number;
	fui_wages_tot_c: string;
	fui_wages_tot_d: Date;
	fui_wages_tot_n: number;
	fui_wages_tot_r: number;
	gp_exported: Date;
	gp_exported_preset: Date;
	id: string;
	is_intercompany: string;
	is_paid: string;
	is_void: string;
	liab_insurance: number;
	liab_insurance_c: string;
	liab_insurance_d: Date;
	liab_insurance_n: number;
	liab_insurance_r: number;
	net_pay: number;
	net_pay_c: string;
	net_pay_d: Date;
	net_pay_n: number;
	net_pay_r: number;
	nontax_pay: number;
	nontax_pay_c: string;
	nontax_pay_d: Date;
	nontax_pay_n: number;
	nontax_pay_r: number;
	old_bal_applied: number;
	old_bal_applied_c: string;
	old_bal_applied_d: Date;
	old_bal_applied_n: number;
	old_bal_applied_r: number;
	other_deduct: number;
	other_deduct_c: string;
	other_deduct_d: Date;
	other_deduct_n: number;
	other_deduct_r: number;
	pay_calc_method: string;
	payee_id: string;
	payee_pay_method: string;
	payee_type: string;
	payperiod_end: Date;
	payperiod_start: Date;
	payroll_cutoffdate: Date;
	post_key: string;
	post_module: string;
	print_driver_orders_dtl: string;
	print_or_wire: string;
	process_type: string;
	puc_tax_wh: number;
	puc_tax_wh_c: string;
	puc_tax_wh_d: Date;
	puc_tax_wh_n: number;
	puc_tax_wh_r: number;
	puc_wages: number;
	puc_wages_c: string;
	puc_wages_d: Date;
	puc_wages_n: number;
	puc_wages_r: number;
	sdi_wages: number;
	sdi_wages_c: string;
	sdi_wages_d: Date;
	sdi_wages_n: number;
	sdi_wages_r: number;
	sdi_wages_tot: number;
	sdi_wages_tot_c: string;
	sdi_wages_tot_d: Date;
	sdi_wages_tot_n: number;
	sdi_wages_tot_r: number;
	sdi_wh: number;
	sdi_wh_c: string;
	sdi_wh_d: Date;
	sdi_wh_n: number;
	sdi_wh_r: number;
	state_tax_id: string;
	state_tax_wh: number;
	state_tax_wh_c: string;
	state_tax_wh_d: Date;
	state_tax_wh_n: number;
	state_tax_wh_r: number;
	state_wages: number;
	state_wages_c: string;
	state_wages_d: Date;
	state_wages_n: number;
	state_wages_r: number;
	sui_tax_code: string;
	sui_wages: number;
	sui_wages_c: string;
	sui_wages_d: Date;
	sui_wages_n: number;
	sui_wages_r: number;
	sui_wages_tot: number;
	sui_wages_tot_c: string;
	sui_wages_tot_d: Date;
	sui_wages_tot_n: number;
	sui_wages_tot_r: number;
	sui_wh: number;
	sui_wh_c: string;
	sui_wh_d: Date;
	sui_wh_n: number;
	sui_wh_r: number;
	tot_a_tax_stded: number;
	tot_a_tax_stded_c: string;
	tot_a_tax_stded_d: Date;
	tot_a_tax_stded_n: number;
	tot_a_tax_stded_r: number;
	tot_aftertax_ded: number;
	tot_aftertax_ded_c: string;
	tot_aftertax_ded_d: Date;
	tot_aftertax_ded_n: number;
	tot_aftertax_ded_r: number;
	tot_b4_tax_ded: number;
	tot_b4_tax_ded_c: string;
	tot_b4_tax_ded_d: Date;
	tot_b4_tax_ded_n: number;
	tot_b4_tax_ded_r: number;
	tot_b4_tax_stded: number;
	tot_b4_tax_stded_c: string;
	tot_b4_tax_stded_d: Date;
	tot_b4_tax_stded_n: number;
	tot_b4_tax_stded_r: number;
	tot_earning_pay: number;
	tot_earning_pay_c: string;
	tot_earning_pay_d: Date;
	tot_earning_pay_n: number;
	tot_earning_pay_r: number;
	tot_gross_pay: number;
	tot_gross_pay_c: string;
	tot_gross_pay_d: Date;
	tot_gross_pay_n: number;
	tot_gross_pay_r: number;
	tot_load_count: number;
	tot_pay_miles: number;
	tot_pay_miles_um: string;
	tot_perdiem_ded: number;
	tot_perdiem_ded_c: string;
	tot_perdiem_ded_d: Date;
	tot_perdiem_ded_n: number;
	tot_perdiem_ded_r: number;
	tot_set_perdiem: number;
	tot_set_perdiem_c: string;
	tot_set_perdiem_d: Date;
	tot_set_perdiem_n: number;
	tot_set_perdiem_r: number;
	tot_settle_pay: number;
	tot_settle_pay_c: string;
	tot_settle_pay_d: Date;
	tot_settle_pay_n: number;
	tot_settle_pay_r: number;
	tot_trailer_rent: number;
	tot_trailer_rent_c: string;
	tot_trailer_rent_d: Date;
	tot_trailer_rent_n: number;
	tot_trailer_rent_r: number;
	tot_workman_comp: number;
	tot_workman_comp_c: string;
	tot_workman_comp_d: Date;
	tot_workman_comp_n: number;
	tot_workman_comp_r: number;
	total_reimb: number;
	total_reimb_c: string;
	total_reimb_d: Date;
	total_reimb_n: number;
	total_reimb_r: number;
	void_date: Date;
}

